import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  upcomingEntities: [],
  upcomingTotalCount: 0,
  upcomingWindowDays: 14,
  stats: null,
  currentPayment: null,
  lastError: null
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const instalmentPaymentsSlice = createSlice({
  name: "instalmentPayments",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      const error = action.payload.error;
      if (error && error.response && error.response.data && error.response.data.message) {
        state.error = error.response.data.message;
      } else if (error && error.message) {
        state.error = error.message;
      } else {
        state.error = `${error}`;
      }
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    instalmentPaymentsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    upcomingPaymentsFetched: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.upcomingEntities = action.payload.entities;
      state.upcomingTotalCount = action.payload.totalCount;
      state.upcomingWindowDays = action.payload.window_days;
    },
    statsFetched: (state, action) => {
      state.stats = action.payload;
    },
    paymentFetched: (state, action) => {
      state.actionsLoading = false;
      state.currentPayment = action.payload;
      state.error = null;
    },
    paymentUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      if (state.currentPayment && state.currentPayment.id === action.payload.id) {
        state.currentPayment = { ...state.currentPayment, ...action.payload };
      }
      state.entities = state.entities.map(entity => {
        if (entity.id === action.payload.id) {
          return { ...entity, ...action.payload };
        }
        return entity;
      });
    }
  }
});
